<template>
  <el-row>
    <table-template :queryParams="queryParams" actionUrl="/clueCar/findBusinessClueCarList.action"
                    ref="Table">
      <template slot="search">
        <el-row>
          <el-form :inline="true" >
            <el-form-item>
              <el-select v-model="queryParams.status" :clearable="true" :filterable="true" placeholder="线索状态">
                <el-option :value="4" label="待清洗"></el-option>
                <el-option :value="5" label="清洗中"></el-option>
                <el-option :value="6" label="审核中"></el-option>
                <el-option :value="1" label="有效线索"></el-option>
                <el-option :value="2" label="成功收车"></el-option>
                <el-option :value="3" label="无效线索"></el-option>
              </el-select>
            </el-form-item>
              <el-form-item>
                <el-select v-model="queryParams.clueChannelType" @change="$refs.Table.search()" :clearable="true" :filterable="true" placeholder="线索渠道类型">
                  <el-option :value="1" label="普通线索"></el-option>
                  <el-option :value="2" label="上汽专区线索"></el-option>
                </el-select>
              </el-form-item>

            <el-form-item>
              <el-select v-model="queryParams.clueLevel" @change="$refs.Table.search()" :clearable="true" :filterable="true" placeholder="线索等级">
                <el-option :value="1" label="普通线索"></el-option>
                <el-option :value="2" label="优质线索"></el-option>
              </el-select>
            </el-form-item>

              <el-form-item>
              <el-date-picker
                  @change="onDateTimeChange"
                  end-placeholder="发布结束日期"
                  range-separator="至"
                  start-placeholder="发布开始日期"
                  type="datetimerange"
                  v-model="queryParams.startEndTime">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-date-picker
                      @change="onMaintenanceDateTimeChange"
                      end-placeholder="维护结束日期"
                      range-separator="至"
                      start-placeholder="维护开始日期"
                      type="datetimerange"
                      v-model="queryParams.maintenanceStartEndTime">
              </el-date-picker>
            </el-form-item>

            <el-form-item  >
              <el-input style="width: 200px" placeholder="搜索维护人 ID 品牌车型" v-model="queryParams.keyword"></el-input>
            </el-form-item>
            <el-form-item  >
              <el-input  placeholder="所在地" v-model="queryParams.carKeyword"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="$refs.Table.search()" type="warning">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button @click="$router.push({path:'/home/intranetClueItem'})" type="primary">新增线索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button @click="exportExcel()" type="warning" v-belong-to-admin>导出</el-button>
            </el-form-item>
          </el-form>
        </el-row>

      </template>
      <template slot="item">

        <el-table-column
            label="车主信息"
            width="120px"
        >
          <template slot-scope="scope">
            <p>ID:{{scope.row.id}} </p>
            <p>{{ scope.row.name }}</p>
            <p>{{ scope.row.phone }}</p>
            <p>来源:{{ scope.row.sourceType }}</p>

          </template>
        </el-table-column>
        <el-table-column
            label="品牌车型"

        >
          <template slot-scope="scope">
            <p>{{scope.row.brand}} {{scope.row.series}}</p>
            <p>{{scope.row.category}}</p>
            <p style="color: red">期望价：{{scope.row.expectedPrice}}</p>
            <p>指导价：{{scope.row.officePrice}}</p>
          </template>
        </el-table-column>
        <el-table-column
            label="车辆档案"

        >
          <template slot-scope="scope">
            <p> 表显里程：{{scope.row.mileage}}万公里</p>

            <p>初次上牌日：{{scope.row.licenseTime}} </p>

            <p>车辆所在地：{{scope.row.locationCity}} </p>

            <p>排放标准/排量：{{scope.row.environmentalstandards}}/{{scope.row.displacement}} </p>
            <p>变速箱：{{scope.row.geartype}} </p>
<!--            <p>使用性质：{{scope.row.useNature}} </p>-->

          </template>
        </el-table-column>
       <el-table-column
               width="120px"
            label="线索描述"
            prop="officeRemark"
        >
        </el-table-column>
        <el-table-column
            label="车辆描述"
            prop="remark"
        >
          <template slot-scope="scope">
            {{scope.row.remark}}
          </template>
        </el-table-column>

        <el-table-column
                label="线索渠道类型"
                width="120px"
        >
          <template slot-scope="scope">
            <p>{{ scope.row.clueChannelType|clueChannelTypeFilter }}</p>
            <p style="color: red">等级：{{ scope.row.clueLevel|clueLevelFilter }}</p>
          </template>
        </el-table-column>

        <el-table-column
            label="线索状态"
            width="120px"
        >
          <template slot-scope="scope">

            <el-dropdown trigger="click"  width="100px">
              <el-button class="el-dropdown-link" size="mini" type="primary">
                {{ scope.row.status|statusFilter }}<i class="el-icon-caret-bottom el-icon--right" style="color:#FFF"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native.prevent="changeClueCarStatus(scope.row.id,2)" >成功收车</el-dropdown-item>

                <el-dropdown-item v-confirm-input :confirm-input-data="{id:scope.row.id,status:3}" confirm-input-text="确定修改成无效线索"
                                  value-alias="officeRemark" requestUrl="clueCar/changeClueCarStatus.action"  confirm-input-placeholder="无效原因"
                                  @onInputConfirm="onInputConfirm">无效线索
                </el-dropdown-item>

                <el-dropdown-item @click.native.prevent="changeClueCarStatus(scope.row.id,5)" >清洗中</el-dropdown-item>
                <el-dropdown-item @click.native.prevent="changeClueCarStatus(scope.row.id,4)" >待清洗</el-dropdown-item>

              </el-dropdown-menu>
            </el-dropdown>

          </template>
        </el-table-column>
        <el-table-column
            label="收车记录"
            width="80px"
        >
          <template scope="scope">
            <el-button type="text" @click="$router.push({path:'/home/intranetClueCarRecord',query:{id:scope.row.id}})"> {{scope.row.clueCarRecordCount}}条</el-button>
          </template>
        </el-table-column>

        <el-table-column
            label="发布时间"
        >
          <template scope="scope">
          <p>{{scope.row.createTime | dateTimeFormat}}(发布)</p>
          <p style="color: red">{{scope.row.maintenanceLastTime | dateTimeFormat}}(维护)</p>
            <p v-if="scope.row.maintenanceName" style="color: red">维护人：{{ scope.row.maintenanceName }}</p>
          </template>
        </el-table-column>
        <el-table-column
            label="操作"
            width="80px"
        >
          <template scope="scope">
            <el-button-group >
              <el-button type="text" @click.native.prevent="$router.push({name:'编辑线索', params: { id: scope.row.id }})"  size="mini">
                修改/审核
                <el-divider direction="vertical"></el-divider>
              </el-button>

              <el-button type="text" size="mini" @click="$router.push({path:'/home/intranetClueCarRecordItem',query:{'clueCarId':scope.row.id}})">记录收车</el-button>

              <el-button type="text" size="mini" @click="$router.push({path:'/home/distributionClueMaintenanceEmployee',query:{'clueCarId':scope.row.id}})">分配维护人</el-button>

              <el-button type="text" v-if="scope.row.shareUrl" @click="openUrl(scope.row.shareUrl)">授权链接</el-button>

            </el-button-group>
            <a v-if="scope.row.pcUrl" target="_blank" :href="scope.row.pcUrl">外网详情</a>
            <el-button type="text" v-if="scope.row.status == 1" @click="sendClue(scope.row.id)">推送线索</el-button>
          </template>
        </el-table-column>
      </template>
    </table-template>
    <el-dialog
        title="提示"
        :visible.sync="urlDialogVisible"
        width="30%"
        center>

      <el-input placeholder="请输入内容" v-model="urlVal">

      </el-input>
      <span slot="footer" class="dialog-footer">
    <el-button @click="urlDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="urlDialogVisible = false">确 定</el-button>
  </span>
    </el-dialog>
  </el-row>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'
import BasicModel from '@/framework/basic/BasicModel'
import Config from '@/framework/configs/Config'

export default {
  components: {
    TableTemplate
  },
  extends: BasicPager,
  name: 'clueIntranetManagement',
  data: function () {
    return {
      urlDialogVisible: false,
      urlVal: '暂无',
      queryParams: {
        status: 6,
        startTime: null,
        endTime: null,
        keyword: null,
        carKeyword: null,
        clueChannelType: null,
        maintenanceStartTime: null,
        maintenanceEndTime: null,
        clueLevel: null
      }
    }
  },
  activated: function () {
    this.$refs.Table.search()
  },
  watch: {
    'queryParams.status': function () {
      this.$refs.Table.search()
    }
  },
  methods: {
    onInputConfirm: function () {
      this.$refs.Table.search()
    },
    sendClue: function (id) {
      this.$confirm('推送线索前，须确认该线索有效（继续卖车），否则请勿推送！', '确定推送有效线索', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let _this = this
        let param = { 'id': id }
        let listener = {
          success: function (dataInfo) {
            if (dataInfo.success) {
              _this.$message({
                message: '推送成功！',
                type: 'success'
              })
              _this.$refs.Table.search()
            } else {
              _this.$message({
                message: '推送失败！',
                type: 'error'
              })
            }
          }
        }
        let action = 'clueCar/sendClue.action'
        BasicModel.post(_this, action, param, listener)
      }).catch(() => {

      })
    },
    onMaintenanceDateTimeChange (dates) {
      if (dates && dates.length === 2) {
        this.queryParams.maintenanceStartTime = dates[0].getTime()
        this.queryParams.maintenanceEndTime = dates[1].getTime()
      } else {
        this.queryParams.maintenanceStartTime = null
        this.queryParams.maintenanceEndTime = null
      }
      this.$refs.Table.search()
    },
    openUrl: function (shareUrl) {
      this.urlDialogVisible = true
      this.urlVal = shareUrl
    },
    exportExcel: function () {
      let _this = this

      let dataStr = ''

      if (this.queryParams.status) {
        dataStr += '&status=' + this.queryParams.status
      }

      if (this.queryParams.maintenanceStartTime) {
        dataStr += '&maintenanceStartTime=' + this.queryParams.maintenanceStartTime
      }

      if (this.queryParams.maintenanceEndTime) {
        dataStr += '&maintenanceEndTime=' + this.queryParams.maintenanceEndTime
      }

      if (this.queryParams.startTime) {
        dataStr += '&startTime=' + this.queryParams.startTime
      }
      if (this.queryParams.clueChannelType) {
        dataStr += '&clueChannelType=' + this.queryParams.clueChannelType
      }

      if (this.queryParams.endTime) {
        dataStr += '&endTime=' + this.queryParams.endTime
      }
      if (this.queryParams.keyword) {
        dataStr += '&keyword=' + this.queryParams.keyword
      }
      if (this.queryParams.carKeyword) {
        dataStr += '&carKeyword=' + this.queryParams.carKeyword
      }
      let userInfo = _this.getLoginInfo()
      let loginPath = userInfo.loginPath
      let id = null
      if (userInfo.id) {
        id = userInfo.id
      } else if (userInfo.employeeId) {
        id = userInfo.employeeId
      }
      window.location.href = Config.baseUrl + 'clueCar/findBusinessClueCarListByAdminExcel.action?' + 'token=' + userInfo.token + '&loginAccountId=' + id + '&loginPath=' + loginPath + dataStr
    },
    changeClueCarStatus (id, status) {
      let _this = this
      let params = { id: id, status: status }
      let listener = {
        success: function (dataInfo) {
          _this.$message({
            type: dataInfo.success ? 'success' : 'error',
            message: dataInfo.errMsg
          })
          _this.$refs.Table.search()
        }

      }

      BasicModel.post(_this, '/clueCar/changeClueCarStatus.action', params, listener)
    },
    onDateTimeChange (dates) {
      if (dates && dates.length === 2) {
        this.queryParams.startTime = dates[0].getTime()
        this.queryParams.endTime = dates[1].getTime()
      } else {
        this.queryParams.startTime = null
        this.queryParams.endTime = null
      }
      this.$refs.Table.search()
    }
  },
  filters: {
    clueChannelTypeFilter: function (val) {
      let str = '非法值'
      switch (val) {
        case 1:
          str = '普通线索'
          break
        case 2:
          str = '上汽专区线索'
          break
      }
      return str
    },
    clueLevelFilter: function (val) {
      let str = '非法值'
      switch (val) {
        case 1:
          str = '普通线索'
          break
        case 2:
          str = '优质线索'
          break
      }
      return str
    },
    statusFilter: function (val) {
      let str = '非法值'
      switch (val) {
        case 1:
          str = '有效线索'
          break
        case 2:
          str = '成功收车'
          break
        case 3:
          str = '无效线索'
          break
        case 4:
          str = '待清洗'
          break
        case 5:
          str = '清洗中'
          break
        case 6:
          str = '审核中'
          break
      }
      return str
    }
  }
}
</script>

<style scoped>
</style>
